var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_MainOrderRegistr"),
        width: "450px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-scrollbar",
        { staticClass: "owned-branch-tree", staticStyle: { height: "400px" } },
        [
          _c("el-tree", {
            attrs: {
              data: _vm.options,
              props: { children: "children", label: "label" },
              "node-key": "value",
              "current-node-key": _vm.value,
              "highlight-current": ""
            },
            on: { "node-click": _vm.handleNodeClick },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var node = ref.node
                  var data = ref.data
                  return [
                    _c(
                      "span",
                      {
                        style:
                          _vm.selectedNodeKey === data.value
                            ? "color: #1F75D5;font-weight: bold;"
                            : "",
                        attrs: { title: data.tip }
                      },
                      [_vm._v(" " + _vm._s(node.label) + " ")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "1" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Close")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "success", no: "2" },
              on: { click: _vm.confirmAssignment }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.CARGO_Confirm_Assignment")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }